// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ClaimsCopyright/ClaimsCopyright.css
// module id = 1961
// module chunks = 0